const createUserActivityResponse = (data) => {
  let res = {}
  res.isEndOfTail = data.isEndOfTail
  res.latestSequenceNumber = 0
  res.userFeedItems = {}
  Object.keys(data.userFeedItems).forEach((key) => {
    res.latestSequenceNumber = data.userFeedItems[key].sequenceNumber
    res.userFeedItems[res.latestSequenceNumber] = data.userFeedItems[key]
  })
  return res
}

export {
  createUserActivityResponse
}



// WEBPACK FOOTER //
// ./src/api/user/normalize.js